import { createAction, props } from '@ngrx/store';
import { BadResponseWithError } from '@shared/models/common.interface';
import { PermissionGroupResponse } from '../../models/api/response/permissions-management.response';
import { addNewGroupRequest } from '../../models/api/requests/permissions-manager.request';
import { IndividualPermissionsResponse } from '../../models/api/response/individual-permissions.response';
import { SmartTableResult } from '@shared/models/smart-table.interface';
import { PlayerProfilesWithPagination } from '../../../user-management/models/api/response/user-management.response';
import { SummaryResponse } from '../../models/api/response/summary.response';

// export type Filter = { [key: string]: string | string[] };

export const FETCH_PERMISSIONS_GROUP_REQUEST =
    '[Permissions] Fetch permissions groups requests';
export const FETCH_PERMISSIONS_GROUP_REQUESTS_SUCCESS =
    '[Permissions] Fetch permissions groups requests success';
export const FETCH_PERMISSIONS_GROUP_REQUESTS_FAILURE =
    '[Permissions] Fetch permissions groups requests failure';

export const fetchPermissionsGroupRequests = createAction(
    FETCH_PERMISSIONS_GROUP_REQUEST,
    props<{
        payload?: SmartTableResult;
    }>()
);

export const fetchPermissionsGroupRequestsSuccess = createAction(
    FETCH_PERMISSIONS_GROUP_REQUESTS_SUCCESS,
    props<{
        payload: {
            items: PermissionGroupResponse[];
        };
    }>()
);

export const fetchPermissionsGroupRequestsFailure = createAction(
    FETCH_PERMISSIONS_GROUP_REQUESTS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const FETCH_PERMISSIONS_REQUEST =
    '[Permissions] Fetch permissions requests';
export const FETCH_PERMISSIONS_REQUESTS_SUCCESS =
    '[Permissions] Fetch permissions requests success';
export const FETCH_PERMISSIONS_REQUESTS_FAILURE =
    '[Permissions] Fetch permissions requests failure';
export const fetchPermissionsRequests = createAction(FETCH_PERMISSIONS_REQUEST);

export const fetchPermissionsRequestsSuccess = createAction(
    FETCH_PERMISSIONS_REQUESTS_SUCCESS,
    props<{
        payload: {
            items: PermissionGroupResponse[];
        };
    }>()
);

export const fetchPermissionsRequestsFailure = createAction(
    FETCH_PERMISSIONS_REQUESTS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const ADD_NEW_PERMISSION_GROUP_REQUEST =
    '[Permissions] Add new permission group request';
export const ADD_NEW_PERMISSION_GROUP_SUCCESS =
    '[Permissions] Add new permission group success';
export const ADD_NEW_PERMISSION_GROUP_FAILURE =
    '[Permissions] Add new permission group failure';

export const addNewPermissionsGroupRequest = createAction(
    ADD_NEW_PERMISSION_GROUP_REQUEST,
    props<{
        payload: addNewGroupRequest;
    }>()
);

export const addNewPermissionsGroupsSuccess = createAction(
    ADD_NEW_PERMISSION_GROUP_SUCCESS,
    props<{
        payload: {
            newGroup: any;
        };
    }>()
);

export const addNewPermissionsGroupFailure = createAction(
    ADD_NEW_PERMISSION_GROUP_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const DELETE_PERMISSION_GROUP_REQUEST =
    '[Permissions] Delete permission group request';
export const DELETE_PERMISSION_GROUP_SUCCESS =
    '[Permissions] Delete permission group success';
export const DELETE_PERMISSION_GROUP_FAILURE =
    '[Permissions] Delete permission group failure';

export const removePermissionsGroupRequest = createAction(
    DELETE_PERMISSION_GROUP_REQUEST,
    props<{
        payload: { id: string };
    }>()
);

export const removePermissionsGroupsSuccess = createAction(
    DELETE_PERMISSION_GROUP_SUCCESS,
    props<{
        payload: {
            id: string;
        };
    }>()
);

export const removePermissionsGroupFailure = createAction(
    DELETE_PERMISSION_GROUP_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const ADD_NEW_USER_TO_PERMISSION_GROUP_REQUEST =
    '[Permissions] Add new users to permissions group request';
export const ADD_NEW_USER_TO_PERMISSION_GROUP_SUCCESS =
    '[Permissions] Add new users to permissions group success';
export const ADD_NEW_USER_TO_PERMISSION_GROUP_FAILURE =
    '[Permissions] Add new users to permissions group failure';

export const addNewUsersToPermissionsGroupRequest = createAction(
    ADD_NEW_USER_TO_PERMISSION_GROUP_REQUEST,
    props<{
        payload: any;
    }>()
);

export const addNewUsersToPermissionsGroupSuccess = createAction(
    ADD_NEW_USER_TO_PERMISSION_GROUP_SUCCESS,
    props<{
        payload: {
            items: any;
        };
    }>()
);

export const addNewUsersToPermissionsGroupFailure = createAction(
    ADD_NEW_USER_TO_PERMISSION_GROUP_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const REMOVE_USER_FROM_PERMISSION_GROUP_REQUEST =
    '[Permissions] Remove users from permissions group request';
export const REMOVE_USER_FROM_PERMISSION_GROUP_SUCCESS =
    '[Permissions] Remove users from permissions group success';
export const REMOVE_USER_FROM_PERMISSION_GROUP_FAILURE =
    '[Permissions] Remove users from permissions group failure';

export const removeUsersFromPermissionsGroupRequest = createAction(
    REMOVE_USER_FROM_PERMISSION_GROUP_REQUEST,
    props<{
        payload: any;
    }>()
);

export const removeUsersFromPermissionsGroupSuccess = createAction(
    REMOVE_USER_FROM_PERMISSION_GROUP_SUCCESS,
    props<{
        payload: {
            items: any;
        };
    }>()
);

export const removeUsersFromPermissionsGroupFailure = createAction(
    REMOVE_USER_FROM_PERMISSION_GROUP_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const ADD_PERMISSIONS_TO_GROUP_REQUEST =
    '[Permissions] Add permissions to group request';
export const ADD_PERMISSIONS_TO_GROUP_SUCCESS =
    '[Permissions] Add permissions to group success';
export const ADD_PERMISSIONS_TO_GROUP_FAILURE =
    '[Permissions] Add permissions to group failure';

export const addPermissionsToGroup = createAction(
    ADD_PERMISSIONS_TO_GROUP_REQUEST,
    props<{
        payload: { id: string; permissions: any[] };
    }>()
);

export const addPermissionsToGroupSuccess = createAction(
    ADD_PERMISSIONS_TO_GROUP_SUCCESS,
    props<{
        payload: {
            items: any;
        };
    }>()
);

export const addPermissionsToGroupFailure = createAction(
    ADD_PERMISSIONS_TO_GROUP_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const DELETE_PERMISSIONS_FROM_GROUP_REQUEST =
    '[Permissions] Delete permissions from group request';
export const DELETE_PERMISSIONS_FROM_GROUP_SUCCESS =
    '[Permissions] Delete permissions from group success';
export const DELETE_PERMISSIONS_FROM_GROUP_FAILURE =
    '[Permissions] Delete permissions from group failure';

export const deletePermissionsFromGroup = createAction(
    DELETE_PERMISSIONS_FROM_GROUP_REQUEST,
    props<{
        payload: { id: string; permissionIds: string[] };
    }>()
);

export const deletePermissionsFromGroupSuccess = createAction(
    DELETE_PERMISSIONS_FROM_GROUP_SUCCESS,
    props<{
        payload: {
            items: any;
        };
    }>()
);

export const deletePermissionsFromGroupFailure = createAction(
    DELETE_PERMISSIONS_FROM_GROUP_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const UPDATE_PERMISSION_GROUP_REQUEST =
    '[Permissions] Update permission group request';
export const UPDATE_PERMISSION_GROUP_SUCCESS =
    '[Permissions] Update permission group success';
export const UPDATE_PERMISSION_GROUP_FAILURE =
    '[Permissions] Update permission group failure';

export const updatePermissionsGroupRequest = createAction(
    UPDATE_PERMISSION_GROUP_REQUEST,
    props<{
        payload: any;
    }>()
);

export const updatePermissionsGroupSuccess = createAction(
    UPDATE_PERMISSION_GROUP_SUCCESS,
    props<{
        payload: {
            items: any;
        };
    }>()
);

export const updatePermissionsGroupFailure = createAction(
    UPDATE_PERMISSION_GROUP_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const FETCH_INDIVIDUAL_PERMISSIONS_REQUEST =
    '[Permissions] Fetch individual permissions request';
export const FETCH_INDIVIDUAL_PERMISSIONS_SUCCESS =
    '[Permissions] Fetch individual permissions success';
export const FETCH_INDIVIDUAL_PERMISSIONS_FAILURE =
    '[Permissions] Fetch individual permissions failure';

export const fetchIndividualPermissionsRequest = createAction(
    FETCH_INDIVIDUAL_PERMISSIONS_REQUEST,
    props<{
        payload: {
            profileId: string;
            contextEntityType: string | null;
            contextEntityId?: string;
        };
    }>()
);

export const fetchIndividualPermissionsSuccess = createAction(
    FETCH_INDIVIDUAL_PERMISSIONS_SUCCESS,
    props<{
        payload: IndividualPermissionsResponse;
    }>()
);

export const fetchIndividualPermissionsFailure = createAction(
    FETCH_INDIVIDUAL_PERMISSIONS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const DUPLICATE_PERMISSION_GROUP_REQUEST =
    '[Permissions] Duplicate permission group request';
export const DUPLICATE_PERMISSION_GROUP_SUCCESS =
    '[Permissions] Duplicate permission group success';
export const DUPLICATE_PERMISSION_GROUP_FAILURE =
    '[Permissions] Duplicate permission group failure';

export const duplicatePermissionGroupRequest = createAction(
    DUPLICATE_PERMISSION_GROUP_REQUEST,
    props<{
        payload: { id: string; groupData: any };
    }>()
);

export const duplicatePermissionGroupSuccess = createAction(
    DUPLICATE_PERMISSION_GROUP_SUCCESS,
    props<{
        payload: {
            newGroup: any;
        };
    }>()
);

export const duplicatePermissionGroupFailure = createAction(
    DUPLICATE_PERMISSION_GROUP_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const FETCH_USERS_IN_GROUP_REQUEST =
    '[Permissions] Fetch users in group request';
export const FETCH_USERS_IN_GROUP_SUCCESS =
    '[Permissions] Fetch users in group success';
export const FETCH_USERS_IN_GROUP_FAILURE =
    '[Permissions] Fetch users in group failure';

export const fetchUsersInGroup = createAction(
    FETCH_USERS_IN_GROUP_REQUEST,
    props<{
        groupId?: string;
        payload?: SmartTableResult;
    }>()
);

export const fetchUsersInGroupSuccess = createAction(
    FETCH_USERS_IN_GROUP_SUCCESS,
    props<{
        payload: PlayerProfilesWithPagination;
    }>()
);

export const fetchUsersInGroupFailure = createAction(
    FETCH_USERS_IN_GROUP_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const ASSIGN_INDIVIDUAL_PERMISSION_REQUEST =
    '[Permissions] Assign individual permission request';
export const ASSIGN_INDIVIDUAL_PERMISSION_SUCCESS =
    '[Permissions] Assign individual permission success';
export const ASSIGN_INDIVIDUAL_PERMISSION_FAILURE =
    '[Permissions] Assign individual permission failure';

export const assignIndividualPermissionRequest = createAction(
    ASSIGN_INDIVIDUAL_PERMISSION_REQUEST,
    props<{
        payload: {
            profileId: string;
            permissions: any[];
        };
    }>()
);

export const assignIndividualPermissionSuccess = createAction(
    ASSIGN_INDIVIDUAL_PERMISSION_SUCCESS,
    props<{
        payload: any;
    }>()
);

export const assignIndividualPermissionFailure = createAction(
    ASSIGN_INDIVIDUAL_PERMISSION_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const FETCH_SUMMARY_REQUEST = '[Permissions] Fetch summary request';
export const FETCH_SUMMARY_SUCCESS = '[Permissions] Fetch summary success';
export const FETCH_SUMMARY_FAILURE = '[Permissions] Fetch summary failure';

export const fetchSummaryRequest = createAction(
    FETCH_SUMMARY_REQUEST,
    props<{
        payload: {
            profileId: string;
            contextEntityType: string | null;
            contextEntityId: string | null;
        };
    }>()
);

export const fetchSummarySuccess = createAction(
    FETCH_SUMMARY_SUCCESS,
    props<{
        payload: any;
    }>()
);

export const fetchSummaryFailure = createAction(
    FETCH_SUMMARY_FAILURE,
    props<{ payload: BadResponseWithError }>()
);
